import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Popover } from "@mui/material";
import { useState } from "react";
import Flex from "./Flex";
import StatusChip from "./StatusChip";
import Text from "./Text";
import { getFormattedId } from "../utils/utils";
import { CHART_TYPOGRAPHY } from "./app/provider/patient/chart";

interface DetailsHoverPopOverListProps {
  data?: string[];
}

const ChipComponent = ({ id }: { id: string }) => {
  return <StatusChip label={getFormattedId(id)} variant="info" />;
};
const DetailsHoverPopOverList = ({ data }: DetailsHoverPopOverListProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  if (!data || data.length === 0) return <>-</>;
  const firstId = data[0];
  const restIds = data.slice(1);
  const open = Boolean(anchorEl);

  return (
    <>
      {data.length === 1 && <ChipComponent id={firstId} />}
      {data.length > 1 && (
        <Flex gap={1} alignItems={"center"}>
          <ChipComponent id={firstId} />
          <Text
            onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
            onMouseLeave={() => setAnchorEl(null)}
            display={"flex"}
            alignItems={"center"}
          >
            <InfoOutlinedIcon
              sx={{
                color: "#0097F0",
                fontSize: CHART_TYPOGRAPHY.body5.fontSize,
              }}
            />
          </Text>
          <Popover
            id="mouse-over-popover"
            anchorEl={anchorEl}
            sx={{ pointerEvents: "none" }}
            open={open}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            onClose={() => setAnchorEl(null)}
            disableRestoreFocus
          >
            <Flex flexWrap={"wrap"} width={150} gap={0.5} p={0.8} m={0.8}>
              {restIds.map((id) => (
                <StatusChip
                  key={id}
                  label={getFormattedId(id)}
                  variant="info"
                />
              ))}
            </Flex>
          </Popover>
        </Flex>
      )}
    </>
  );
};

export default DetailsHoverPopOverList;
